import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import Button from "../components/ResubleComp/Button";

//expert logion main function
const Expertlogin = ({ onLogin }) => {
  //states
  const [google, setGoogle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  // const { toggleShowPassword } = props;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  //state to show password and confirm passwrod
  const [showPassword, setShowPassword] = useState(false);

  //error messages for input fileds
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  let navigate = useNavigate();


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async () => {
    setLoading(true);
    //handling error messages for name email and password
    let hasError = false;
    if (email === "") {
      setEmailError("E-Mail is a required field");
      hasError = true;
    } else {
      setEmailError(""); // Clear the error message
    }

    if (password === "") {
      setPasswordError("password is a required field");
      hasError = true;
    } else {
      setPasswordError(""); // Clear the error message
    }

    if (hasError) {
      setLoading(false);
      return; // Don't proceed if there are errors
    }
    try {
      const url = baseUrl + "/api/expert/login";
      const data = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      setLoading(false);
      const response = await data.json();
      if (data.status === 201) {
        const token = response.data.token;

        onLogin(token, response.data.expert);

        localStorage.setItem("EXPERT_AUTH_TOKEN", token);
        localStorage.setItem(
          "EXPERT_INFO",
          JSON.stringify(response.data.expert)
        );

        navigate("/problemsolver/dashboard");
      } else if (data.status === 404 || data.status === 400) {
        setEmailError(response.error.message);
      } else if (data.status === 401) {
        setPasswordError(response.error.message);
      } else if (data.status === 500) {
        setEmailError("An error occurred. Please try again later.");
        console.error("Internal Server Error:", response);
      }
    } catch (error) {
      // Handle network errors or any unexpected exceptions
      setEmailError("An error occurred. Please try again later.");
      console.error("Unhandled Error:", error);
      toast.error("Internal Server Error: ", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const checkUserExisting = async (userDetail, id_token) => {
    setLoading(true);
    const URL = baseUrl + `/api/expert/google?id_token=${id_token}`; //queryparams =>id_token
    const response = await axios.post(URL, userDetail, {
      headers: {
        "Content-type": "application/json",
      },
    });
    if (response.status === 200) {
      localStorage.setItem("TOKEN", response?.data?.existingUser?.token);
      localStorage.setItem("userId", response?.data?.existingUser?._id);
      localStorage.setItem(
        "userINfo",
        JSON.stringify(response.data.existingUser)
      );
      navigate("/Next2LoginPageexpert");
    } else if (response.status === 201) {
      localStorage.setItem("TOKEN", response?.data.user.existingUser?.token);
      localStorage.setItem("userId", response?.data.user.existingUser?._id);
      localStorage.setItem(
        "userINfo",
        JSON.stringify(response.data.user.existingUser)
      );
      navigate("/");
    }
    setLoading(false);
  };

  const firebaseConfig = {
    apiKey: "AIzaSyCPCH-BQL99kpu5DLgiB98PUR5-6IUoN7E",
    authDomain: "fynii-37e06.firebaseapp.com",
    projectId: "fynii-37e06",
    storageBucket: "fynii-37e06.appspot.com",
    messagingSenderId: "399892740732",
    appId: "1:399892740732:web:bf8bbf6f338da41f26a7f9",
    measurementId: "G-QSVT0N891D",
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();

  // const GoogleAuth = () => {
  //   signInWithPopup(auth, provider).then((result) => {
  //     setGoogle(result);
  //     const usercresd = {
  //       email: result.user.email,
  //       uid: result.user.uid,
  //       displayName: result.user.displayName,
  //       photoURL: result.user.photoURL,
  //     };
  //     const id_token = result._tokenResponse.idToken;
  //     checkUserExisting(usercresd, id_token);
  //   });
  // };

  const GoogleAuth = () => {
    window.open(`${baseUrl}/auth/google/callback`, "_self");
  };

  return (
    <div className="h-screen bg-gray-100 lg:flex lg:justify-center lg:items-center">
      <div
        id="LoginFormUser"
        className="m-5 p-5 lg:p-5  rounded-lg bg-white lg:w-1/4 lg:flex mx-auto"
      >
        <div className="w-full">
          <h3 className="font-josefin-sans font-bold text-xl text-center">
            Welcome Back!
          </h3>
          <div className="flex flex-col -mx-2 mb-4 mt-5">
            <div className="w-full">
              <label
                className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                htmlFor="email"
              >
                E-mail <span className="text-red-600">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                id="email"
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {emailError && (
                <p className="text-red-500 text-xs mt-1">{emailError}</p>
              )}
            </div>

            <div className="w-full mb-4 md:mb-0 relative">
              <label
                className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                htmlFor="password"
              >
                Password <span className="text-red-500">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                id="password"
                placeholder="Your password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 right-5 cursor-pointer"
              >
                {showPassword ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
              {passwordError && (
                <p className="text-red-500 text-xs mt-1">{passwordError}</p>
              )}
            </div>

            <div className="w-full mt-5">
              <Button
                className="bg-blue-400 w-full font-semibold rounded flex justify-center items-center text-gray-900 py-3 "
                onClick={() => {
                  handleSubmit();
                }}
              >
                Log In
                {/* {loading && <CircularProgress color="primary" />} */}
              </Button>
            </div>
            <div className="text-center">or</div>
            <div className="w-full" onClick={GoogleAuth}>
              <button
                id="googlebutton"
                className="bg-white px-3 font-semibold w-full rounded flex justify-center items-center text-gray-700 py-3 border border-gray-400 "
                onClick={GoogleAuth}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  className="rounded-full bg-white w-5 mx-2 hover:bg-gray-200"
                  alt=""
                />
                Continue with Google
              </button>
            </div>
          </div>
          <div className="w-full mt-4">
            <p className="text-center text-gray-600">
              New here?
              <span className="ml-2 text-blue-500 cursor-pointer underline">
                <a href="/problemsolver/signup">Sign Up</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertlogin;
